import { upperFirst, lowerCase } from 'lodash';
import { formatToIsoDate, formatToLocalDate } from '@/utils';

export default {
  name: 'ActivityEvents',
  components: {},
  props: {
    inputForm: {
      type: Object,
      default: undefined,
    },
    inputFormType: {
      type: String,
      default: '',
    },
    enums: {
      type: Array,
      default: [],
    },
  },
  data: () => ({
    showConfirm: false,
    indexIdToDelete: null,
    activityEvents: [],
    formFields: {
      activityEventType: {
        name: 'activityEventType',
        label: 'Type',
      },
      activityEventDate: {
        name: 'activityEventDate',
        label: 'Date',
      },
    },
  }),
  computed: {
    show() {
      const showForInputTypes = ['PortEngineArrival', 'Inspection'];
      return showForInputTypes.includes(this.inputFormType);
    },
    activityEventTypeDropdownValues() {
      const activityEventTypeEnums = this.enums.length > 0 && this.enums.find(e => e.name === 'ActivityEventType') != null ? this.enums.find(e => e.name === 'ActivityEventType').values : [];

      if (activityEventTypeEnums.lenght === 0) {
        return [];
      }

      const activityEventTypeEnumsByInputFormType = activityEventTypeEnums.filter(aete => aete.includes(this.inputFormType));
      const activityEventTypeEnumsByInputFormTypeFormatted = activityEventTypeEnumsByInputFormType.map((entry) => {
        const entryWithoutInputFormType = entry.replace(this.inputFormType, '');
        const entryWithoutInputFormTypeFormatted = upperFirst(lowerCase(entryWithoutInputFormType));
        return {
          name: entryWithoutInputFormTypeFormatted,
          value: entry,
        };
      });

      return activityEventTypeEnumsByInputFormTypeFormatted;
    },
  },
  methods: {
    addActivityEvent() {
      const activityEvent = {
        activityEventType: '',
        activityEventDate: null,
      };

      this.activityEvents.push(activityEvent);
    },
    setConfirm(index) {
      this.indexIdToDelete = index;
      this.showConfirm = true;
    },
    cancelConfirm() {
      this.indexIdToDelete = null;
      this.showConfirm = false;
    },
    deleteActivityEvent(index) {
      this.activityEvents.splice(index, 1);
      this.showConfirm = false;
    },
    onInputFormSaved() {
      this.sendInputForm();
    },
    sendInputForm() {
      if (this.show) {
        const activityEventsObject = [];

        this.activityEvents.forEach((activityEvent) => {
          if (activityEvent.activityEventType !== '' && activityEvent.activityEventDate !== null) {
            const activityEventObject = {
              activityEventType: activityEvent.activityEventType,
              activityEventDate: formatToIsoDate(activityEvent.activityEventDate),
            };

            activityEventsObject.push(activityEventObject);
          }
        });

        this.$eventHub.$emit('fetch-activity-events-info', activityEventsObject);
      }
    },
  },
  watch: {
    inputForm() {
      if (this.inputForm != null && this.inputForm.activityEvents.length > 0) {
        this.activityEvents = this.inputForm.activityEvents.map((activityEvent) => {
          /* eslint-disable */
          activityEvent.activityEventType = activityEvent.activityEventType;
          activityEvent.activityEventDate = formatToLocalDate(activityEvent.activityEventDate);

          return { ...activityEvent };
         });
      }
    },
    inputFormType() {
      if (this.inputForm != null && this.inputForm.inputType !== this.inputFormType) {
        this.activityEvents = [{
          activityEventType: '',
          activityEventDate: null,
        }];
      }
    },
  },
  created() {
    this.$eventHub.$on('on-input-form-saved', this.onInputFormSaved);

    if (this.activityEvents.length === 0) {
      this.addActivityEvent();
    }
  },
};
